import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "NEMA_5-20R",
  "use": "NEMA_5-20R-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"NEMA_5-20R\"><path d=\"M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5zm0 1.5C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm8.5-19.5h-3v10h3v-5h4v-2h-4v-3zM30 22h4v5h-4v5h-6V19h6v3zm-19.5-.5v8h3v-8h-3zM9 20h6v11H9V20zm6.5-13.5V13a4.5 4.5 0 109 0V6.5h-9zM14 5h12v8a6 6 0 11-12 0V5z\" fill=\"#000\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol